module.exports = __webpack_public_path__ + "src/assets/textures/env/barn/barn_inner_walls_512_bake.png";